import { Box, Button, Container, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { isEmpty, isNil } from 'lodash/fp'
import { FormsProps } from '../../types'
import log from 'loglevel'
import { domainName, httpRequest } from '../../functions/common'
import { Loading } from '../Loading'

log.setLevel(log.levels.DEBUG)

export const RegistCreditCard = (props: FormsProps) => {
  const { formData } = props
  const { memberId } = formData
  const [url, setUrl] = useState<string>('')
  const [isLoading, setLoading] = useState<boolean>(true)
  useEffect(() => {
    if (!isNil(memberId)) {
      const setButtonsUrl = async () => {
        const response = await httpRequest(
          'get',
          `https://${domainName}/v1/entry/credit-regist/${memberId}`
        )
        if (isNil(response)) {
          log.error(
            '[common.getEditCreditCardUrl] cannot get edit credit card url'
          )
          return undefined
        }
        const { status, data } = response
        if (status === 200) {
          setUrl(data)
          setLoading(false)
        }
      }
      setButtonsUrl()
    }
  }, [])

  const handleButtonClick = () => {
    if (!isNil(url)) {
      window.open(url, '_blank')
    }
  }

  return isLoading ? (
    <Loading />
  ) : (
    <Box paddingTop={3}>
      <Typography
        align="left"
        variant="h4"
        sx={{
          borderLeft: 20,
          borderBottom: 1,
          borderColor: 'orange',
          paddingLeft: 1
        }}>
        お支払方法登録
      </Typography>
      <Container maxWidth="md">
        <Box mt={2}>現在のお支払い方法はクレジット決済のみとなります。</Box>
        <Box mb={3}>
          下記のボタンを押すと、決済代行会社の画面へ遷移します。お申込みには、お支払い情報の入力が必須となります。
        </Box>
        <Typography variant="caption">
          ※テラシテでは、カード情報の不正使用を未然に防止するため、3Dセキュア2.0を導入いたしました。<br />
          つきましては、3Dセキュア2.0のサービス登録設定済のクレジットカードをご利用ください。<br />
          クレジットカードの3Dセキュア2.0の設定方法につきましては、ご利用のカード発行会社のWebサイトなどでご確認ください。<br />
        </Typography>
        <Box display={'flex'} justifyContent={'center'} paddingTop={3}>
          <Button
            variant="contained"
            disabled={isEmpty(url)}
            onClick={handleButtonClick}>
            お支払い情報のご登録
          </Button>
        </Box>
      </Container>
    </Box>
  )
}
